<template>
    <div>
        <div class="shop_header">
            <nav>
                <ul class="cl-ul cl-display--flex cl-flex--row cl-flex--wrap cl-align--center">
                    <li>
                        <a href="/" class="home" itemprop="item">
                            <svg class="svg-inline--fa fa-home fa-w-18" aria-hidden="true" focusable="false"
                                data-prefix="fas" data-icon="home" role="img" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 576 512" data-fa-i2svg="">
                                <path fill="currentColor"
                                    d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z">
                                </path>
                            </svg><!-- <i class="fas fa-home"></i> Font Awesome fontawesome.com -->
                            <span style="display: none;" itemprop="name">首頁</span>
                        </a>
                    </li>
                    <li>{{ details.group_name }}</li>
                </ul>
            </nav>
        </div>
        <div class='shopitem'>
            <div class="shop_content" id="shop_content">
                <div class="shop">
                    <div class="shop_left">
                        <div class="swiper">
                            <swiper v-show="true" ref="Swiper" :thumbs="{ swiper: thumbsSwiper }" @slideChange="updateActiveSlideIndex"
                                :slides-per-view="1" :autoHeight="true" :options="swiperOptions" :navigation="true"
                                :observer='true' :observeParents='true'>
                                <!-- :observeParents='true' :observer='true' -->
                                <swiper-slide class="test" v-for="itemsimg in details?.items">
                                    <img v-lazy="itemsimg.display_img_small" alt="">
                                </swiper-slide>
                            </swiper>
                            <div class="swiper-pagination"></div>
                        </div>
                        <div class="swiper_thumbs">
                            <swiper v-show="true" ref="thumbSwiper" @swiper="setThumbsSwiper" :allowTouchMove="false"
                                :slides-per-view="1" :loop="false"  slidesPerView='auto' :centeredSlides="false">
                                <swiper-slide class="test" v-for="itemsimg, index in details?.items" :key="index"
                                    watch-slides-visibility watch-slides-progress
                                    :class="{ 'active-slide': index === activeSlideIndex }">
                                    <img v-lazy="itemsimg.display_img_small" alt="img" />
                                </swiper-slide>
                            </swiper>
                        </div>
                    </div>
                    <div class="shop_right">
                        <!-- <span>{{ item.name }}</span> -->
                        <h4>{{ details.group_name }}</h4>
                        <p style="white-space: pre-line;">
                            {{ details.content }}
                        </p>

                        <div class="price" v-if="list_index == null">
                            <span>${{ details.price_min | formatNumberToqff }}</span>
                            <del>${{ details.price_original_max | formatNumberToqff }}</del>
                        </div>
                        <div v-else class="price">
                            <span>${{ list_num_price | formatNumberToqff }}</span>
                            <!-- <del>${{ item.price_original_max | formatNumberToqff}}</del> -->
                        </div>
                        <div class="specification">
                            <div style="margin-bottom: 5px;">規格</div>
                            <!-- <div class="option selected">复古绿</div>
                            <div class="option">复古红</div>
                            <div class="option">复古黄</div>
                            <div class="option">复古黄</div> -->
                            <div @click="selectlist(index)" :class="{ selected: list_index === index }" class="option"
                                v-for="(list, index) in details.items">{{ list.name }}
                            </div>
                        </div>
                        <div class="mb_pc">
                            <div class="number">
                                <button type="button" class="btn iconfont" @click="reduce()">-
                                </button>
                                <input @change="handleChange(list_num)" type="number" name="quantity" v-model="list_num"
                                    class="border-0 text-center w-100   p-0" data-max="1" data-min="1">
                                <button type="button" class="btn iconfont" @click="add()">+
                                </button>
                            </div>
                            <div class="addcart">
                                <div class="svg">
                                    <a :href="number != 0 ? '/cart' : '/'" class="cl-a">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg" class="qk-text--text">
                                            <path d="M1 1H3.86592L7.40731 18H20" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M5 4H23L21.2347 14.0711L7.29582 15" stroke="currentColor"
                                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M11.9199 10.1201H16.2299" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path
                                                d="M7 23C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21C6.44772 21 6 21.4477 6 22C6 22.5523 6.44772 23 7 23Z"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round"></path>
                                            <path
                                                d="M20 23C20.5523 23 21 22.5523 21 22C21 21.4477 20.5523 21 20 21C19.4477 21 19 21.4477 19 22C19 22.5523 19.4477 23 20 23Z"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round"></path>
                                        </svg>
                                        <span>{{ number }}</span>
                                    </a>
                                </div>
                                <div class="btncart">
                                    <div class="cart" @click="addToCart()">
                                        加入購物車
                                    </div>
                                    <div class="gocart" @click="gocart">
                                        立即購買
                                    </div>
                                </div>
                                <!-- <div class="cart" @click="addToCart">
                                    加入購物車
                                </div> -->
                                <div class="buy" @click="gocart">
                                    立即購買
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="padding-top: 40px;"></div>
                <div class="desc_sections" id="desc_sections" ref="desc_sections">
                    <ul id="desc_sections_ul"
                        class="cl-ul cl-display--flex cl-flex--row cl-flex--wrap cl-align--center">
                        <li><a href="#desc" class="cl-a">商品介紹</a> </li>
                        <li><a href="#notice" class="cl-a">規格說明</a></li>
                        <li><a href="#delivery" class="cl-a">注意事項</a></li>
                        <li id="mb_addcart" class="dis_nonde"><a href="javascript:;">
                                <div class="pos" @click="addToCart">
                                    加入購物車
                                </div>
                            </a></li>
                    </ul>
                </div>
                <div class="shop_details">
                    <h5 id="desc">| 商品介绍</h5>
                    <div v-for="item in details?.info?.desc">
                        <img v-if="item.content_type == 'IMAGE'" :src="item.content" alt="">
                        <div class="video-wrapper" v-else-if="item.content_type == 'YOUTUBE' && item.content">
                            <iframe :src="'https://www.youtube.com/embed/' + item.content.split('v=')[1].split('&')[0]"
                                frameborder="0" allowfullscreen></iframe>
                        </div>
                        <div v-else>
                            {{ item.content }}
                        </div>
                    </div>
                    <h5 id="notice">| 規格說明</h5>
                    <div v-for="item in details?.info?.notice">
                        <img v-if="item.content_type == 'IMAGE'" :src="item.content" alt="">
                        <!-- <div class="video-wrapper" v-else-if="item.content_type == 'YOUTUBE'">
                                <iframe :src="'https://www.youtube.com/embed/' + item.content.split('v=')[1].split('&')[0]"
                                    frameborder="0" allowfullscreen></iframe>
                            </div> -->
                        <div v-else>
                            {{ item.content }}
                        </div>
                    </div>
                    <h5 id="delivery">| 注意事項</h5>
                    <div v-for="item in details?.info?.delivery">
                        <img v-if="item.content_type == 'IMAGE'" :src="item.content" alt="">
                        <!-- <div class="video-wrapper" v-else-if="item.content_type == 'YOUTUBE'">
                                <iframe :src="'https://www.youtube.com/embed/' + item.content.split('v=')[1].split('&')[0]"
                                    frameborder="0" allowfullscreen></iframe>
                            </div> -->
                        <div v-else>
                            {{ item.content }}
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <el-dialog :visible.sync="ChildDialogVisible" class="child_dialog">
            <!-- <Child_list @dialog_close="dialog_close" :list_itemid="this.list_itemid" :child_list="this.child_list"
                :child_num="this.child_num" :list_num="this.list_num"></Child_list> -->
            <h2>請選擇 {{ this.child_num }} 份商品</h2>
            <div v-for="item, index in child_list">
                <div class="form_name">{{ item.form_name }}</div>
                <div class="number">
                    <button type="button" class="btn iconfont" @click="decrement(index)">-
                    </button>
                    <input type="number" name="quantity" @input="validateInput(index)" v-model="item.display_num"
                        class="border-0 text-center w-100   p-0" data-max="1" data-min="1">
                    <button type="button" class="btn iconfont" @click="increment(index)">+
                    </button>
                </div>
            </div>
            <div class="btn">
                <button @click="checkChild_list">確認</button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Child_list from '@/components/child_list.vue'
import Vue from 'vue';
import numeral from "numeral";
import { mapState } from 'vuex';
import { Carousel, CarouselItem, Dialog, Loading, InputNumber } from 'element-ui';
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(InputNumber);
Vue.use(Dialog);
Vue.use(Loading);
// import { Navigation, Pagination, Thumbs } from 'swiper'
// import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import { Swiper as SwiperClass, Navigation, Pagination, Thumbs } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper-vue2'
import 'swiper/swiper-bundle.css'
// SwiperCore.use([Navigation, Pagination, Thumbs])
SwiperClass.use([Navigation, Pagination, Thumbs])
import FacebookEventApi from '@/js/FacebookEventApi'
import GA4EventApi from '@/js/GA4EventApi';
export default {
    components: {
        Swiper,
        SwiperSlide,
        Child_list
    },
    data() {
        return {
            item: [],
            swiperOptions: {

            },
            ChildDialogVisible: false,
            //子商品
            child_list: [],//子商品内容
            child_num: '',//子商品默认数量
            child_number: '',//记录商品数量总和
            parm: [],//修改后的子商品各个的数量

            //赠品
            free: [],//赠品
            free_num: '',//赠品数量
            free_number: '',//记录赠品数量总和
            free_parm: [],//修改后的赠品各个的数量

            issub: false,
            thumbsSwiper: null,
            activeSlideIndex: 0,
            list_index: null,//选择規格
            list_num: 1,//选择規格后的数量
            list_price: null,//选择規格后的价格
            list_itemid: null,//选择規格后的itemid
            list_price: null,//选择規格后的价格
            list_num_price: null,//选择規格后的数量*价格

            // addtocart2
            content_name: '',//商品名字
            content_ids: '',//id
            values: '',//价格
            contents_quantity: ''//数量
        };
    },
    computed: {
        ...mapState('cart', ['number', 'cart_list_item']),
        ...mapState('commodity', ['details']),
        ...mapState('header', ['getfb']),
        totalSum() {
            return this.child_list.reduce((sum, item) => sum + item.display_num, 0);
        }
    },
    filters: {
        formatNumberToqff(val) {
            return numeral(val).format('0,0');
        }
    },
    watch: {},
    methods: {
        addToCart(item) {
            if (this.list_index == null) {
                this.$notify({
                    title: '未選擇規格',
                    type: 'warning'
                });
            } else {

                var myFacebookEventApi = new FacebookEventApi(this.getfb.ShenV1FbPixel1, this.getfb.ShenV1FbPixel1_hash);
                var fb_em = myFacebookEventApi.fbgetCookie('em');
                var fb_phone = myFacebookEventApi.fbgetCookie('phone');
                var fb_fn = myFacebookEventApi.fbgetCookie('fn');
                var fb_external_id = myFacebookEventApi.fbgetCookie('external_id');
                var fb_fbclid = myFacebookEventApi.fbgetCookie('fbclid');
                myFacebookEventApi.callAddToCart2('item' + this.content_ids, this.content_name, this.contents_quantity, this.values, fb_em, fb_phone, fb_fn, fb_external_id, fb_fbclid);
                var GAFourEventApi = new GA4EventApi();
                GAFourEventApi.add_to_cart(this.item, this.content_ids, this.list_num);
                if (this.issub) {
                    if (this.parm.length === 0) {
                        this.$notify({
                            title: '請先選擇子商品',
                            type: 'warning'
                        });
                        this.ChildDialogVisible = true;
                    } else {
                        this.$swal.fire({
                            allowOutsideClick: false, // 禁止点击外部关闭弹窗
                            customClass: {
                                popup: 'custom-swal'
                            },
                            didOpen: () => {
                                this.$swal.showLoading(); // 显示加载动画
                            }
                        });
                        this.parm = this.child_list.map(item => {
                            return {
                                item: item.isubid,
                                num: item.display_num
                            };
                        });
                        this.parm.forEach(element => {
                            element.num = element.num * this.list_num;
                        });
                        this.free_parm = this.free.map(item => {
                            // number_free += item.display_num
                            return {
                                item: item.isubid,
                                num: this.free_num * this.list_num
                            };
                        });
                        this.child_number = this.list_num
                        if (this.cart_list_item.length != 0) {
                            this.cart_list_item.forEach(element => {
                                if (this.list_itemid == element.item_id) {
                                    this.child_number += element.num
                                    element.sub.forEach(sub_item => {
                                        const existingItem = this.parm.find(item1 => item1.item === sub_item.isubid);
                                        if (existingItem) {
                                            // 如果存在，则将数量相加
                                            existingItem.num += sub_item.num;
                                        }
                                        const free_existingItem = this.free_parm.find(item1 => item1.item === sub_item.isubid);
                                        if (free_existingItem) {
                                            // 如果存在，则将数量相加
                                            free_existingItem.num += sub_item.num;
                                        }
                                    });
                                }
                            });
                        }
                        this.parm = this.parm.concat(this.free_parm);
                        this.$store.dispatch('cart/child_update', {
                            itemid: this.list_itemid,
                            number: this.child_number,
                            param: this.parm
                        }).then(response => {
                            this.$swal.fire({
                                html: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="73.4" height="73.4" viewBox="0 0 73.4 73.4">
          <circle class="circle" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="36.7" cy="36.7" r="35.2"></circle>
          <polyline class="success_path" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="23.7,36.8 32.4,45.4 49.7,28 "></polyline>
        </svg><div>已加入購物車</div>`,
                                showConfirmButton: false,
                                customClass: {
                                    popup: 'icon-popup'
                                },
                            });
                            // 设置延时器在一秒后关闭弹窗
                            setTimeout(() => {
                                this.$swal.close();
                            }, 1000); // 1000 毫秒等于 1 秒
                        });
                    }

                } else {
                    this.$swal.fire({
                        allowOutsideClick: false, // 禁止点击外部关闭弹窗
                        customClass: {
                            popup: 'custom-swal'
                        },
                        didOpen: () => {
                            this.$swal.showLoading(); // 显示加载动画
                        }
                    });
                    this.parm = this.child_list.map(item => {
                        return {
                            item: item.isubid,
                            num: item.display_num
                        };
                    });
                    this.parm.forEach(element => {
                        element.num = element.num * this.list_num;
                    });
                    this.free_parm = this.free.map(item => {
                        // number_free += item.display_num
                        return {
                            item: item.isubid,
                            num: this.free_num * this.list_num
                        };
                    });
                    this.child_number = this.list_num
                    if (this.cart_list_item.length != 0) {
                        this.cart_list_item.forEach(element => {
                            if (this.list_itemid == element.item_id) {
                                this.child_number += element.num
                                element.sub.forEach(sub_item => {
                                    const existingItem = this.parm.find(item1 => item1.item === sub_item.isubid);
                                    if (existingItem) {
                                        // 如果存在，则将数量相加
                                        existingItem.num += sub_item.num;
                                    }

                                    const free_existingItem = this.free_parm.find(item1 => item1.item === sub_item.isubid);
                                    if (free_existingItem) {
                                        // 如果存在，则将数量相加
                                        free_existingItem.num += sub_item.num;
                                    }
                                });

                            }
                        });
                    }
                    this.parm = this.parm.concat(this.free_parm);
                    this.$store.dispatch('cart/child_update', {
                        itemid: this.list_itemid,
                        number: this.child_number,
                        param: this.parm
                    }).then(response => {
                        if (response.result) {
                            this.$swal.fire({
                                html: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="73.4" height="73.4" viewBox="0 0 73.4 73.4">
          <circle class="circle" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="36.7" cy="36.7" r="35.2"></circle>
          <polyline class="success_path" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="23.7,36.8 32.4,45.4 49.7,28 "></polyline>
        </svg><div>已加入購物車</div>`,
                                showConfirmButton: false,
                                customClass: {
                                    popup: 'icon-popup'
                                },
                            });
                        } else {
                            this.$swal.fire({
                                html: `<svg xmlns="http://www.w3.org/2000/svg" width="73.4" height="73.4" viewBox="0 0 73.4 73.4">
        <line fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" x1="20" y1="20" x2="53.4" y2="53.4" />
        <line fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" x1="53.4" y1="20" x2="20" y2="53.4" />
    </svg>
    <div>${response.message}</div>`,
                                showConfirmButton: false,
                                customClass: {
                                    popup: 'icon-popup'
                                },
                            });
                        }
                        // 设置延时器在一秒后关闭弹窗
                        setTimeout(() => {
                            this.$swal.close();
                        }, 1000); // 1000 毫秒等于 1 秒
                    });
                }
            }

        },
        close() {

        },
        // 轮播缩略图
        setThumbsSwiper(swiper) {
            this.thumbsSwiper = swiper;
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
                this.thumbsSwiper.update(); // 强制更新 Swiper 尺寸
            }, 1000); // 延迟执行以确保 DOM 已完全渲染
        },
        //缩略图添加样式
        updateActiveSlideIndex(swiper) {
            this.activeSlideIndex = swiper.activeIndex;
            swiper.slideTo(this.activeSlideIndex);
        },
        // 弹出框打开置顶
        resetScroll() {
            this.$nextTick(() => {
                const element = document.getElementById('shop_content');
                if (element) {
                    element.scrollTop = 0;
                }
            });
        },
        handleChange() {
            console.log(123);
        },
        updateNavHeaderHeight() {
            var navHeaderHeight = document.getElementById('header').offsetHeight;
            document.getElementById('router_viewbody').style.paddingTop = navHeaderHeight + 'px';
            return navHeaderHeight;
        },
        addScrollListener() {
            // 获取navheader的高度
            // // 监听滚动事件
            var desc_sections_ul = document.getElementById('desc_sections_ul');
            var mb_addcart = document.getElementById('mb_addcart');
            var lastScrollTop = 0;
            window.addEventListener('scroll', () => {
                var navHeaderHeight = this.updateNavHeaderHeight();
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                if (this.$refs.desc_sections) {

                    let tablistTop = this.$refs.desc_sections.getBoundingClientRect();
                    if (tablistTop.top < 0) {
                        desc_sections_ul.classList.add("desc_sections_ul");
                        mb_addcart.classList.add('mb_addcart');
                    } else {
                        desc_sections_ul.classList.remove("desc_sections_ul");
                        mb_addcart.classList.remove('mb_addcart');
                    }
                    if (scrollTop > lastScrollTop) {
                        // 向下滚动
                        if (scrollTop > navHeaderHeight) {
                            desc_sections_ul.style.top = '0';
                        }
                    } else {
                        // 向上滚动
                        desc_sections_ul.style.top = navHeaderHeight + 'px';
                    }

                    lastScrollTop = scrollTop;
                }
            });


        },
        getOffsetTop(element) {
            let offsetTop = 0;
            while (element) {
                offsetTop += element.offsetTop;
                element = element.offsetParent;
            }
            return offsetTop;
        },
        // 选择規格
        selectlist(e) {
            this.list_price = this.details.items[e].price;
            this.list_num_price = this.list_price * this.list_num;
            this.list_itemid = this.details.items[e].itemid;
            // console.log();
            this.list_index = e;
            this.getProducts(this.details.items[e].itemid);
            this.parm = [];

            this.$refs.Swiper.swiperRef.slideTo(e);
            this.activeSlideIndex =e;
            this.content_name = this.item.items[e].form_name;
            this.content_ids = this.item.items[e].itemid;
            this.values = this.item.items[e].price;
            this.contents_quantity = 1;
        },
        //数量减少
        reduce() {
            if (this.list_num > 1) {
                this.list_num--;
            } else {
                this.list_num = 1;
            }
            this.list_num_price = this.list_price * this.list_num;
        },
        //数量增加
        add() {
            if (this.list_index == null) {
                this.$notify({
                    title: '未選擇規格',
                    type: 'warning'
                });
            } else {
                this.list_num++;
            }
            this.list_num_price = this.list_price * this.list_num;
        },
        //修改商品数量
        handleChange(val) {
            if (this.list_index == null) {
                this.$notify({
                    title: '未選擇規格',
                    type: 'warning'
                });
                this.list_num = 1;
            } else {
                this.list_num = val;
            }
            this.list_num_price = this.list_price * this.list_num;
        },
        //前往购物车
        gocart() {
            if (this.list_index == null) {
                this.$notify({
                    title: '未選擇規格',
                    type: 'warning'
                });
            } else {

                var myFacebookEventApi = new FacebookEventApi(this.getfb.ShenV1FbPixel1, this.getfb.ShenV1FbPixel1_hash);
                var fb_em = myFacebookEventApi.fbgetCookie('em');
                var fb_phone = myFacebookEventApi.fbgetCookie('phone');
                var fb_fn = myFacebookEventApi.fbgetCookie('fn');
                var fb_external_id = myFacebookEventApi.fbgetCookie('external_id');
                var fb_fbclid = myFacebookEventApi.fbgetCookie('fbclid');
                myFacebookEventApi.callAddToCart2('item' + this.content_ids, this.content_name, this.contents_quantity, this.values, fb_em, fb_phone, fb_fn, fb_external_id, fb_fbclid);
                var GAFourEventApi = new GA4EventApi();
                GAFourEventApi.add_to_cart(this.item, this.content_ids, this.list_num);
                if (this.issub) {
                    if (this.parm.length === 0) {
                        this.$notify({
                            title: '請先選擇子商品',
                            type: 'warning'
                        });
                        this.ChildDialogVisible = true;
                    } else {
                        this.$swal.fire({
                            allowOutsideClick: false, // 禁止点击外部关闭弹窗
                            customClass: {
                                popup: 'custom-swal'
                            },
                            didOpen: () => {
                                this.$swal.showLoading(); // 显示加载动画
                            }
                        });
                        this.parm = this.child_list.map(item => {
                            return {
                                item: item.isubid,
                                num: item.display_num
                            };
                        });
                        this.parm.forEach(element => {
                            element.num = element.num * this.list_num;
                        });
                        this.free_parm = this.free.map(item => {
                            // number_free += item.display_num
                            return {
                                item: item.isubid,
                                num: this.free_num * this.list_num
                            };
                        });
                        this.child_number = this.list_num
                        if (this.cart_list_item.length != 0) {
                            this.cart_list_item.forEach(element => {
                                if (this.list_itemid == element.item_id) {
                                    this.child_number += element.num
                                    element.sub.forEach(sub_item => {
                                        const existingItem = this.parm.find(item1 => item1.item === sub_item.isubid);
                                        if (existingItem) {
                                            // 如果存在，则将数量相加
                                            existingItem.num += sub_item.num;
                                        }
                                        const free_existingItem = this.free_parm.find(item1 => item1.item === sub_item.isubid);
                                        if (free_existingItem) {
                                            // 如果存在，则将数量相加
                                            free_existingItem.num += sub_item.num;
                                        }
                                    });
                                }
                            });
                        }
                        this.parm = this.parm.concat(this.free_parm);
                        this.$store.dispatch('cart/child_update', {
                            itemid: this.list_itemid,
                            number: this.child_number,
                            param: this.parm
                        }).then(response => {
                            this.$swal.fire({
                                html: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="73.4" height="73.4" viewBox="0 0 73.4 73.4">
          <circle class="circle" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="36.7" cy="36.7" r="35.2"></circle>
          <polyline class="success_path" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="23.7,36.8 32.4,45.4 49.7,28 "></polyline>
        </svg><div>已加入購物車</div>`,
                                showConfirmButton: false,
                                customClass: {
                                    popup: 'icon-popup'
                                },
                            });
                            // 设置延时器在一秒后关闭弹窗
                            setTimeout(() => {
                                this.$swal.close();
                            }, 1000); // 1000 毫秒等于 1 秒
                            this.$router.push({ path: '/cart' });
                        });
                    }

                } else {
                    this.$swal.fire({
                        allowOutsideClick: false, // 禁止点击外部关闭弹窗
                        customClass: {
                            popup: 'custom-swal'
                        },
                        didOpen: () => {
                            this.$swal.showLoading(); // 显示加载动画
                        }
                    });
                    this.parm = this.child_list.map(item => {
                        return {
                            item: item.isubid,
                            num: item.display_num
                        };
                    });
                    this.parm.forEach(element => {
                        element.num = element.num * this.list_num;
                    });
                    this.free_parm = this.free.map(item => {
                        // number_free += item.display_num
                        return {
                            item: item.isubid,
                            num: this.free_num * this.list_num
                        };
                    });
                    this.child_number = this.list_num
                    if (this.cart_list_item.length != 0) {
                        this.cart_list_item.forEach(element => {
                            if (this.list_itemid == element.item_id) {
                                this.child_number += element.num
                                element.sub.forEach(sub_item => {
                                    const existingItem = this.parm.find(item1 => item1.item === sub_item.isubid);
                                    if (existingItem) {
                                        // 如果存在，则将数量相加
                                        existingItem.num += sub_item.num;
                                    }

                                    const free_existingItem = this.free_parm.find(item1 => item1.item === sub_item.isubid);
                                    if (free_existingItem) {
                                        // 如果存在，则将数量相加
                                        free_existingItem.num += sub_item.num;
                                    }
                                });

                            }
                        });
                    }
                    this.parm = this.parm.concat(this.free_parm);
                    this.$store.dispatch('cart/child_update', {
                        itemid: this.list_itemid,
                        number: this.child_number,
                        param: this.parm
                    }).then(response => {
                        if (response.result) {
                            this.$swal.fire({
                                html: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="73.4" height="73.4" viewBox="0 0 73.4 73.4">
          <circle class="circle" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="36.7" cy="36.7" r="35.2"></circle>
          <polyline class="success_path" fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="23.7,36.8 32.4,45.4 49.7,28 "></polyline>
        </svg><div>已加入購物車</div>`,
                                showConfirmButton: false,
                                customClass: {
                                    popup: 'icon-popup'
                                },
                            });
                        } else {
                            this.$swal.fire({
                                html: `<svg xmlns="http://www.w3.org/2000/svg" width="73.4" height="73.4" viewBox="0 0 73.4 73.4">
        <line fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" x1="20" y1="20" x2="53.4" y2="53.4" />
        <line fill="none" stroke="#898989" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" x1="53.4" y1="20" x2="20" y2="53.4" />
    </svg>
    <div>${response.message}</div>`,
                                showConfirmButton: false,
                                customClass: {
                                    popup: 'icon-popup'
                                },
                            });
                        }
                        // 设置延时器在一秒后关闭弹窗
                        setTimeout(() => {
                            this.$swal.close();
                        }, 1000); // 1000 毫秒等于 1 秒
                        this.$router.push({ path: '/cart' });
                    });
                }
            }

        },
        //子商品
        getProducts(id) {
            this.$store.dispatch('commodity/getsubcategory', id).then(response => {
                // this.products = this.$store.getters["commodity/products"];
                // console.log(response);
                if (response.result) {
                    this.child_list = response.data.sub || [];
                    this.child_num = response.data.num || 0;
                    this.free = response.data.sub_free || [];
                    this.free_num = response.data.num_free || 0;
                    if (response.data.sub.length === 1) {
                        this.child_list[0].display_num = response.data.num
                        switch (response.data.sub_free.length) {
                            case 0:
                                this.parm = [
                                    {
                                        item: response.data.sub[0].isubid,
                                        num: response.data.num
                                    }
                                ]
                                break;
                            default:
                                this.free_parm = this.free.map(item => {
                                    // number_free += item.display_num
                                    return {
                                        item: item.isubid,
                                        num: this.free_num * this.list_num
                                    };
                                });
                                this.parm = [
                                    {
                                        item: response.data.sub[0].isubid,
                                        num: response.data.num
                                    }
                                ]
                                break;
                        }
                        this.issub = true
                    } else
                        if (response.data.num != 0) {
                            this.ChildDialogVisible = true;

                            this.issub = true
                        } else if (response.data.sub.length === 0) {

                            switch (response.data.sub_free.length) {
                                case 0:
                                    this.parm = [
                                    ]
                                    break;
                                default:
                                    this.free_parm = this.free.map(item => {
                                        // number_free += item.display_num
                                        return {
                                            item: item.isubid,
                                            num: this.free_num * this.number
                                        };
                                    });
                                    this.parm = [
                                    ]
                                    break;
                            }
                            this.issub = false
                        }
                } else {
                    this.$notify({
                        title: `${response.message}`,
                        type: 'warning'
                    });
                    this.issub = false
                }
            });
        },
        increment(index) {
            if (this.totalSum < this.child_num) {
                this.child_list[index].display_num++;
            }
        },
        validateInput(index) {
            // 确保当前输入是一个有效数字
            this.child_list[index].display_num = Math.max(0, parseInt(this.child_list[index].display_num) || 0);

            // 计算所有 display_num 的总和
            let total = this.child_list.reduce((sum, item) => sum + item.display_num, 0);

            // 如果总和超过 child_num，则减少当前输入的值
            if (total > this.child_num) {
                let excess = total - this.child_num;
                this.child_list[index].display_num = Math.max(0, this.child_list[index].display_num - excess);
            }
        },
        decrement(index) {
            if (this.child_list[index].display_num > 0) {
                this.child_list[index].display_num--;
            }
        },
        checkChild_list() {
            let number = 0
            this.parm = this.child_list.map(item => {
                number += item.display_num
                return {
                    item: item.isubid,
                    num: item.display_num
                };
            });
            // if (this.cart_list_item.length != 0) {
            //     this.cart_list_item.forEach(element => {
            //         if (this.list_itemid == element.item_id) {
            //             this.list_num += element.num
            //             element.sub.forEach(sub_item => {
            //                 const existingItem = this.parm.find(item1 => item1.item === sub_item.isubid);
            //                 if (existingItem) {
            //                     // 如果存在，则将数量相加
            //                     existingItem.num += sub_item.num;
            //                 }
            //             });
            //         }
            //     });
            // }
            if (number == this.child_num) {
                // console.log(this.parm, this.list_num);
                this.ChildDialogVisible = false
                // this.$emit('dialog_close', { parm: this.parm, number: this.num });
            } else {
                this.$notify({
                    title: `數量選擇有錯哦! 您可以選 ${this.child_num} 樣商品^_^`,
                    type: 'warning'
                });
            }
        },
    },
    created() {
    },
    mounted() {
        const GAFourEventApi = new GA4EventApi();

        this.addScrollListener();
        sessionStorage.setItem("mob", 'details');
        this.$store.dispatch('commodity/getdesignated_product', this.$route.params.id).then(response => {
            this.item = this.$store.getters["commodity/details"];
            this.loading = false;
            GAFourEventApi.view_item(this.item);
        })
        // const rect = document.getElementById('desc_sections_ul').getBoundingClientRect();
        // const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        // console.log(rect.top + scrollTop); 
        // let tablistTop = this.$refs.desc_sections.getBoundingClientRect();
        // console.log(tablistTop);
    },
    destroyed() {
        if (this.thumbsSwiper) {
            this.thumbsSwiper.destroy(true, true);
            this.thumbsSwiper = null;
        }
    }
}
</script>

<style src="./index.scss" lang='scss' scoped></style>